import { authHeader } from '../../_helpers';
import axios from 'axios';

export const developmentPlanService = {
    getdevelopmentPlan,
    updateRespondentsHandler,
    getRelationList,
    updateRelationListHandler
};


axios.defaults.headers.common = authHeader();

function getdevelopmentPlan() {
    return axios.get(`/masters/development/plan/list/create/`)
        .then(response => {
            return response;
        });
}

function getRelationList(){
    
    axios.defaults.headers.common = authHeader();
    let token = localStorage.getItem('access_token')

    return axios.get(`/masters/assessor/group/list/?access_token=${token}`)
    .then(response=> {
        return response;
    })
}

function updateRespondentsHandler(data,id){
    return axios.post(`/masters/development/plan/edit/minimum/respondents/`+id+`/`,data)
    .then(response => {
        return response;
    })
}

function updateRelationListHandler(data,id){
    return axios.post(`/masters/development/plan/edit/relation/`+id+`/`,data)
    .then(response=> {
        return response;
    })
}


// WEBPACK FOOTER //
// ./src/_services/developmentPlan/developmentPlan.service.js